import React from 'react';

import { Box, BoxProps, Group, MantineColor, Text, ThemeIcon } from '@mantine/core';

import cx from './DashboardPanel.module.scss';

const DashboardPanel = ({
    icon,
    color = 'brand',
    title,
    rightSection,
    header,
    flushBottom,
    shadedHeader,
    live,
    className,
    children,
    ...props
}: {
    icon?: React.ReactNode;
    color?: MantineColor;
    title?: React.ReactNode;
    rightSection?: React.ReactNode;
    header?: React.ReactNode;
    flushBottom?: boolean;
    shadedHeader?: boolean;
    live?: boolean;
    children: React.ReactNode;
} & BoxProps) => (
    <Box
        className={[cx.panel, live && `animation-border-spin ${cx.live}`, className].filter(Boolean).join(' ')}
        data-flush-bottom={flushBottom || undefined}
        data-shaded-header={shadedHeader || undefined}
        {...props}
    >
        {(header || title || rightSection) && (
            <Group className={cx.panelHeader} justify="space-between" align="center" gap="xs">
                {header ?? (
                    <Group gap="sm" wrap="nowrap">
                        {icon && (
                            <ThemeIcon variant="light" color={color} size="md" radius="sm" fz={16}>
                                {icon}
                            </ThemeIcon>
                        )}
                        <Text fw={700} fz="md" component="div">
                            {title}
                        </Text>
                    </Group>
                )}
                {rightSection}
            </Group>
        )}
        <Box className={cx.panelBody}>{children}</Box>
    </Box>
);

export { DashboardPanel };
